import { useState, useEffect } from 'react';
import Reveal from '../components/Reveal';
import { SERVICES, CLIENTS, CASE_STUDIES, FAQS, TESTIMONIALS } from '../data';

// Dynamic imports for client logos
import rdLogo   from '../assets/client_royaldivine.jpeg';
import rpLogo   from '../assets/client_redplanet.jpeg';
import siLogo   from '../assets/client_soldinsight.webp';
import srdLogo  from '../assets/client_srd.png';

const CLIENT_LOGOS = { 'client_royaldivine.jpeg': rdLogo, 'client_redplanet.jpeg': rpLogo, 'client_soldinsight.webp': siLogo, 'client_srd.png': srdLogo };

function StarRating({ n = 5 }) {
  return <div style={{ color: '#F7C948', fontSize: 14, letterSpacing: 2 }}>{'★'.repeat(n)}</div>;
}

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: '1px solid var(--bdr)' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{ width: '100%', padding: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', gap: 16 }}
      >
        <span style={{ fontWeight: 600, fontSize: 16, color: 'var(--txt)', fontFamily: 'var(--fB)' }}>{q}</span>
        <span style={{ fontSize: 22, color: 'var(--acc)', transition: 'transform .3s', transform: open ? 'rotate(45deg)' : 'none', flexShrink: 0 }}>+</span>
      </button>
      {open && <p style={{ paddingBottom: 20, color: 'var(--mut)', fontSize: 15, lineHeight: 1.8 }}>{a}</p>}
    </div>
  );
}

export default function Home({ navigate, openForm }) {
  const [counts, setCounts] = useState({ spend: 0, leads: 0 });
  useEffect(() => {
    const dur = 1800, start = performance.now();
    const tick = now => {
      const p = Math.min((now - start) / dur, 1);
      const e = 1 - Math.pow(1 - p, 3);
      setCounts({ spend: Math.round(40 * e), leads: Math.round(5000 * e) });
      if (p < 1) requestAnimationFrame(tick);
    };
    setTimeout(() => requestAnimationFrame(tick), 400);
  }, []);

  return (
    <div>

      {/* ════════════ HERO ════════════ */}
      <section style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'hidden', paddingTop: 80 }}>
        <div style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: '#00E5CC', opacity: 0.05, filter: 'blur(100px)', top: -200, right: -100, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', width: 500, height: 500, borderRadius: '50%', background: '#FF6B35', opacity: 0.05, filter: 'blur(100px)', bottom: -100, left: -100, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(0,229,204,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(0,229,204,0.025) 1px,transparent 1px)', backgroundSize: '60px 60px' }} />
        <div className="hide-mobile" style={{ position: 'absolute', right: '6%', top: '15%', width: 340, height: 340, border: '1px dashed rgba(0,229,204,0.12)', borderRadius: '50%', animation: 'spin 30s linear infinite' }} />

        <div className="hide-mobile" style={{ position: 'absolute', right: '7%', top: '32%', background: 'var(--bg2)', border: '1px solid rgba(0,229,204,0.2)', borderRadius: 14, padding: '16px 22px', animation: 'float 5s ease-in-out infinite', zIndex: 2 }}>
          <div style={{ fontSize: 10, color: 'var(--mut)', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 4 }}>Ad Spend Managed</div>
          <div style={{ fontFamily: 'var(--fD)', fontSize: 30, fontWeight: 900, color: 'var(--acc)' }}>₹{counts.spend}L+</div>
        </div>
        <div className="hide-mobile" style={{ position: 'absolute', right: '20%', top: '64%', background: 'var(--bg2)', border: '1px solid rgba(255,107,53,0.2)', borderRadius: 14, padding: '16px 22px', animation: 'float 5s ease-in-out 1.5s infinite', zIndex: 2 }}>
          <div style={{ fontSize: 10, color: 'var(--mut)', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 4 }}>Happy Clients</div>
          <div style={{ fontFamily: 'var(--fD)', fontSize: 30, fontWeight: 900, color: 'var(--acc2)' }}>20+</div>
        </div>

        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ maxWidth: 680 }}>
            <div style={{ animation: 'fadeUp 0.8s ease forwards', opacity: 0 }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(0,229,204,0.08)', border: '1px solid rgba(0,229,204,0.2)', borderRadius: 100, padding: '6px 16px', marginBottom: 28 }}>
                <span style={{ width: 6, height: 6, background: 'var(--acc)', borderRadius: '50%', animation: 'blink 1.5s ease infinite' }} />
                <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--acc)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Real Estate Performance Marketing</span>
              </div>
            </div>

            <div style={{ animation: 'fadeUp 0.8s 0.1s ease forwards', opacity: 0 }}>
              <h1 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(46px,6.5vw,82px)', fontWeight: 900, lineHeight: 1.0, letterSpacing: '-0.02em', marginBottom: 24 }}>
                Igniting Real Estate<br />
                <span className="g-text">Growth.</span>
              </h1>
            </div>

            <div style={{ animation: 'fadeUp 0.8s 0.2s ease forwards', opacity: 0 }}>
              <p style={{ fontSize: 'clamp(16px,1.8vw,19px)', color: 'var(--mut)', maxWidth: 560, lineHeight: 1.8, marginBottom: 40 }}>
                We help real estate <strong style={{ color: 'var(--txt)' }}>developers and channel partners</strong> grow through expert Meta Ads, Google Ads, Social Media Management & Branding.
              </p>
            </div>

            <div style={{ animation: 'fadeUp 0.8s 0.3s ease forwards', opacity: 0 }}>
              <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 60 }}>
                <button onClick={openForm} className="btn btn-teal" style={{ fontSize: 16, padding: '15px 30px' }}>Get Free Consultation →</button>
                <a href="https://wa.me/917290066328" target="_blank" rel="noreferrer" className="btn btn-wa" style={{ fontSize: 16, padding: '15px 30px' }}>💬 WhatsApp Us</a>
                <button onClick={() => navigate('portfolio')} className="btn btn-ghost" style={{ fontSize: 16, padding: '15px 30px' }}>See Case Studies</button>
              </div>
            </div>

            <div style={{ animation: 'fadeUp 0.8s 0.4s ease forwards', opacity: 0 }}>
              <div style={{ display: 'flex', gap: 44, flexWrap: 'wrap' }}>
                {[['₹40L+','Ad Spend Managed'], ['20+','Happy Clients'], ['4+','Services']].map(([v, l]) => (
                  <div key={l}>
                    <div style={{ fontFamily: 'var(--fD)', fontSize: 36, fontWeight: 900, color: 'var(--acc)', lineHeight: 1 }}>{v}</div>
                    <div style={{ color: 'var(--mut)', fontSize: 13, marginTop: 4 }}>{l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ════════════ CLIENT LOGOS ════════════ */}
      <section style={{ padding: '48px 0', borderTop: '1px solid var(--bdr)', overflow: 'hidden', position: 'relative' }}>
        <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 80, background: 'linear-gradient(to right, var(--bg), transparent)', zIndex: 2 }} />
        <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 80, background: 'linear-gradient(to left, var(--bg), transparent)', zIndex: 2 }} />
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <span style={{ color: 'var(--mut)', fontSize: 12, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>Trusted By</span>
        </div>
        <div style={{ display: 'flex', width: 'max-content', animation: 'marquee 26s linear infinite' }}>
          {[...CLIENTS, ...CLIENTS, ...CLIENTS, ...CLIENTS].map((c, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '0 40px', whiteSpace: 'nowrap' }}>
              <div style={{ width: 52, height: 52, borderRadius: 10, overflow: 'hidden', background: '#000', border: '1px solid rgba(255,255,255,0.1)', flexShrink: 0 }}>
                <img src={CLIENT_LOGOS[c.logo]} alt={c.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <span style={{ fontFamily: 'var(--fD)', fontWeight: 700, fontSize: 16, color: 'var(--mut)', opacity: 0.6 }}>{c.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ════════════ SERVICES ════════════ */}
      <section className="section">
        <div className="container">
          <Reveal>
            <span className="tag">Our Services</span>
            <h2 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(30px,4.5vw,52px)', fontWeight: 900, lineHeight: 1.05, marginBottom: 52 }}>
              Everything your real estate<br />brand needs to grow.
            </h2>
          </Reveal>
          <div className="grid-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
            {SERVICES.map((s, i) => (
              <Reveal key={s.id} delay={i * 0.1}>
                <div onClick={() => navigate('services')} className="card" style={{ padding: 28, background: s.bg, borderColor: s.border, cursor: 'pointer' }}>
                  <div style={{ fontSize: 34, color: s.color, marginBottom: 14 }}>{s.icon}</div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: s.color, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 8 }}>{s.short}</div>
                  <h3 style={{ fontFamily: 'var(--fD)', fontSize: 20, fontWeight: 900, marginBottom: 12 }}>{s.title}</h3>
                  <p style={{ color: 'var(--mut)', fontSize: 14, lineHeight: 1.75, marginBottom: 16 }}>{s.desc}</p>
                  <span style={{ color: s.color, fontWeight: 600, fontSize: 14 }}>Learn More →</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════ CASE STUDIES ════════════ */}
      <section className="section" style={{ background: 'var(--bg2)', borderTop: '1px solid var(--bdr)' }}>
        <div className="container">
          <Reveal>
            <span className="tag" style={{ background: 'rgba(255,107,53,0.08)', borderColor: 'rgba(255,107,53,0.2)', color: 'var(--acc2)' }}>Proven Results</span>
            <h2 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(30px,4.5vw,52px)', fontWeight: 900, lineHeight: 1.05, marginBottom: 52 }}>
              Real Results,<br />Real Estate.
            </h2>
          </Reveal>
          <div className="grid-2" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px,1fr))' }}>
            {CASE_STUDIES.map((cs, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div onClick={() => navigate('portfolio')} className="card" style={{ padding: 28, cursor: 'pointer' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 22 }}>
                    <div style={{ width: 52, height: 52, borderRadius: 11, overflow: 'hidden', background: '#000', border: '1px solid rgba(255,255,255,0.1)', flexShrink: 0 }}>
                      <img src={CLIENT_LOGOS[cs.logo]} alt={cs.client} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div>
                      <div style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 17 }}>{cs.client}</div>
                      <div style={{ fontSize: 11, color: cs.color, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginTop: 2 }}>{cs.type}</div>
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, background: 'var(--bg3)', borderRadius: 12, padding: '16px 14px', marginBottom: 18 }}>
                    {cs.metrics.map((m, j) => (
                      <div key={j} style={{ textAlign: 'center' }}>
                        <div style={{ fontFamily: 'var(--fD)', fontSize: 20, fontWeight: 900, color: cs.color, lineHeight: 1 }}>{m.val}</div>
                        <div style={{ fontSize: 10, color: 'var(--mut)', marginTop: 4, lineHeight: 1.3 }}>{m.label}</div>
                      </div>
                    ))}
                  </div>
                  <p style={{ color: 'var(--mut)', fontSize: 13, fontStyle: 'italic', lineHeight: 1.65 }}>"{cs.quote}"</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 36 }}>
            <button onClick={() => navigate('portfolio')} className="btn btn-ghost">View All Case Studies →</button>
          </div>
        </div>
      </section>

      {/* ════════════ TESTIMONIALS ════════════ */}
      <section className="section" style={{ borderTop: '1px solid var(--bdr)' }}>
        <div className="container">
          <Reveal>
            <span className="tag" style={{ background: 'rgba(247,201,72,0.08)', borderColor: 'rgba(247,201,72,0.2)', color: 'var(--acc3)' }}>Client Reviews</span>
            <h2 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(28px,4vw,48px)', fontWeight: 900, marginBottom: 48 }}>
              What our clients say.
            </h2>
          </Reveal>
          <div className="grid-2" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px,1fr))' }}>
            {TESTIMONIALS.map((t, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div className="card" style={{ padding: 32 }}>
                  <StarRating n={t.rating} />
                  <p style={{ color: 'var(--txt)', fontSize: 15, lineHeight: 1.8, margin: '16px 0 24px', fontStyle: 'italic' }}>
                    "{t.review}"
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 44, height: 44, borderRadius: 10, overflow: 'hidden', background: '#000', border: '1px solid rgba(255,255,255,0.1)', flexShrink: 0 }}>
                      <img src={CLIENT_LOGOS[t.logo]} alt={t.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 14 }}>{t.name}</div>
                      <div style={{ fontSize: 12, color: 'var(--mut)' }}>{t.role}</div>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════ PRICING TEASER ════════════ */}
      <section className="section" style={{ borderTop: '1px solid var(--bdr)', background: 'var(--bg2)' }}>
        <div className="container">
          <Reveal>
            <div style={{ background: 'linear-gradient(135deg,rgba(0,229,204,0.07),rgba(255,107,53,0.05),rgba(155,138,248,0.07))', border: '1px solid var(--bdr)', borderRadius: 24, padding: '56px 48px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'var(--acc)', opacity: 0.04, filter: 'blur(80px)', top: -100, right: -80, pointerEvents: 'none' }} />
              <h2 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(26px,4vw,48px)', fontWeight: 900, marginBottom: 14, position: 'relative' }}>
                Plans starting at <span style={{ color: 'var(--acc)' }}>₹8,000/month</span>
              </h2>
              <div style={{ display: 'flex', gap: 24, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 36 }}>
                {[['Social Media','₹8,000/mo'],['Meta / Google Ads','₹15,000/mo'],['Growth Bundle','₹20,000/mo'],['Branding','Custom']].map(([n, p]) => (
                  <div key={n} style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 13, color: 'var(--mut)', marginBottom: 4 }}>{n}</div>
                    <div style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 18, color: 'var(--acc)' }}>{p}</div>
                  </div>
                ))}
              </div>
              <p style={{ color: 'var(--mut)', fontSize: 16, maxWidth: 440, margin: '0 auto 36px', lineHeight: 1.75 }}>
                No lock-ins. No hidden fees. Flexible packages for channel partners and large developers alike.
              </p>
              <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
                <button onClick={() => navigate('pricing')} className="btn btn-teal">View All Plans →</button>
                <button onClick={openForm} className="btn btn-ghost">Get Custom Quote</button>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ════════════ FAQ ════════════ */}
      <section className="section" style={{ borderTop: '1px solid var(--bdr)' }}>
        <div className="container" style={{ maxWidth: 740 }}>
          <Reveal>
            <h2 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(28px,4vw,48px)', fontWeight: 900, marginBottom: 48 }}>
              Common Questions.
            </h2>
          </Reveal>
          {FAQS.map((f, i) => <FAQItem key={i} q={f.q} a={f.a} />)}
        </div>
      </section>

      {/* ════════════ FINAL CTA ════════════ */}
      <section className="section" style={{ borderTop: '1px solid var(--bdr)', textAlign: 'center', background: 'var(--bg2)' }}>
        <div className="container">
          <Reveal>
            <h2 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(28px,5vw,60px)', fontWeight: 900, lineHeight: 1.0, marginBottom: 20 }}>
              Ready to grow your<br /><span className="g-text">real estate business?</span>
            </h2>
            <p style={{ color: 'var(--mut)', fontSize: 18, marginBottom: 40, lineHeight: 1.7 }}>Free strategy call. No obligations.</p>
            <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button onClick={openForm} className="btn btn-teal" style={{ fontSize: 16, padding: '16px 34px' }}>Get Started Free →</button>
              <a href="https://wa.me/917290066328" target="_blank" rel="noreferrer" className="btn btn-wa" style={{ fontSize: 16, padding: '16px 34px' }}>💬 WhatsApp Now</a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
